"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.Store = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _vue = _interopRequireDefault(require("vue"));

var _lodash = _interopRequireDefault(require("lodash"));

var _vueJsonView = require("vue-json-view");

var _utils = require("../utils");

var _transformLang = require("../utils/transformLang");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var transAllStr2Text = _vueJsonView.Utils.transAllStr2Text;

function getFormItemByConfig(list) {
  var preLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var preName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var result = [];
  list.forEach(function (item) {
    var component = (0, _transformLang.transformLang)(item.component, 'zh');
    var newLabel = [].concat((0, _toConsumableArray2.default)(preLabel), [component.label]);
    var newName = [].concat((0, _toConsumableArray2.default)(preName), [component.name]);

    if (component.tag === 'mh-form-item' || component.tag === 'mh-link-table' || component.tag === 'mh-json-view') {
      result.push(_objectSpread(_objectSpread({}, component), {}, {
        label: newLabel.join('.') || newName.join('.'),
        name: newName.join('.')
      }));
    }

    if (item.children.length) {
      result = [].concat((0, _toConsumableArray2.default)(result), (0, _toConsumableArray2.default)(getFormItemByConfig(item.children, newLabel, newName)));
    }
  });
  return result;
}

var uid = 0;

var Store = /*#__PURE__*/function () {
  function Store() {
    (0, _classCallCheck2.default)(this, Store);
    this.allConfigs = {};
    this.list = [];
    this.current = -1;
    this.currentList = this.list;
    this.formProperty = {
      tag: 'mh-form',
      layout: 'vertical'
    };
    this.defaultLang = 'zh';
  }

  (0, _createClass2.default)(Store, [{
    key: "currentField",
    get: function get() {
      var currentList = this.currentList,
          current = this.current;

      if (current === -1) {
        return undefined;
      }

      return currentList[current];
    }
  }, {
    key: "formItemList",
    get: function get() {
      return getFormItemByConfig(this.list);
    }
    /**
     * 组件列表添加组件
     * @param configs
     */

  }, {
    key: "addConfigs",
    value: function addConfigs(configs) {
      var _this = this;

      configs.forEach(function (config) {
        _this.allConfigs[config.name] = config;
      });
    }
  }, {
    key: "transDragChild",
    value: function transDragChild(child, obj) {
      var _this2 = this;

      if (child.tag === 'drag-board' || child.tag === 'drag-child-container') {
        child.list = obj.children;
        child.zIndex = 1;
        return;
      }

      if (child.children && Array.isArray(child.children)) {
        child.children.forEach(function (c) {
          _this2.transDragChild(c, obj);
        });
      }
    }
    /**
     * 复制配置到面板中
     * @param config
     */

  }, {
    key: "cloneConfig",
    value: function cloneConfig(config) {
      var name = config.name;

      if (!config.fixedName) {
        name = name + '_' + new Date().valueOf();
      }

      var obj = _objectSpread(_objectSpread({}, _lodash.default.cloneDeep(config)), {}, {
        children: [],
        name: name,
        uid: uid++
      });

      obj.component.name = name;
      obj.component._componentName = config.name;

      if (obj.dragComponent) {
        this.transDragChild(obj.dragComponent, obj);
        obj.dragComponent._lang = obj.component._lang;
      }

      return _vue.default.observable(obj);
    }
    /**
     * 点击组件时，添加组件到面板
     * @param field
     */

  }, {
    key: "addField",
    value: function addField(field) {
      var currentList = this.currentList,
          current = this.current;
      var newField = this.cloneConfig(field);
      var index = currentList.length;

      if (current === -1) {
        currentList.push(newField);
      } else {
        index = current + 1;
        currentList.splice(index, 0, newField);
      }
    }
    /**
     * 移除面板中当前组件
     */

  }, {
    key: "removeField",
    value: function removeField() {
      var currentList = this.currentList,
          current = this.current;
      currentList.splice(current, 1);

      if (current === currentList.length) {
        this.current -= 1;
      }
    }
    /**
     * 设置当前组件
     * @param current
     * @param currentList
     */

  }, {
    key: "setCurrent",
    value: function setCurrent(current, currentList) {
      this.current = current;
      this.currentList = currentList;
    }
    /**
     * 重置组件面板
     */

  }, {
    key: "reset",
    value: function reset() {
      this.list = [];
      this.currentList = this.list;
      this.current = -1;
      this.formProperty = {
        tag: 'mh-form',
        layout: 'vertical'
      };
    }
  }, {
    key: "component2Config",
    value: function component2Config(component) {
      var _this3 = this;

      var componentName = component._componentName;
      var name = componentName || component.name || '';

      if (!componentName && name.includes('_')) {
        name = name.substring(0, name.indexOf('_'));
      }

      var newComponent = _objectSpread(_objectSpread({}, component), {}, {
        _componentName: name,
        _type: undefined,
        _childLang: undefined
      });

      var config = this.allConfigs[name] || {
        property: []
      };
      var children = [];

      if (config.childrenTarget && newComponent[config.childrenTarget]) {
        children = newComponent[config.childrenTarget];
        newComponent[config.childrenTarget] = [];
      }

      if (children.length > 0) {
        children = children.map(function (c) {
          return _this3.component2Config(c);
        });
      }

      var obj = _lodash.default.cloneDeep(_objectSpread(_objectSpread({}, config), {}, {
        component: newComponent,
        name: component.name,
        children: children,
        uid: uid++
      }));

      if (obj.dragComponent) {
        this.transDragChild(obj.dragComponent, obj);
        obj.dragComponent._lang = newComponent._lang;
      }

      return _vue.default.observable(obj);
    }
    /**
     * 设置面板组件
     * @param json
     */

  }, {
    key: "setJson",
    value: function setJson(json) {
      var _this4 = this;

      var formObj = JSON.parse(json);
      this.formProperty = _objectSpread(_objectSpread({}, formObj), {}, {
        children: undefined
      });

      if (formObj && formObj.children && Array.isArray(formObj.children)) {
        this.list = formObj.children.map(function (component) {
          return _this4.component2Config(component);
        });
      }
    }
    /**
     * 配置转组件
     * @param config
     */

  }, {
    key: "config2Component",
    value: function config2Component(config) {
      var _this5 = this;

      var obj = _objectSpread(_objectSpread({}, config.component), {}, {
        _type: transAllStr2Text(config.type, config.component),
        _childLang: config._childLang || config.childrenTarget
      });

      if (config.childrenTarget) {
        obj[config.childrenTarget] = config.children.map(function (c) {
          return _this5.config2Component(c);
        });
      }

      return (0, _utils.filterNullList)(obj);
    }
    /**
     * 将面板组件导出为 json
     */

  }, {
    key: "getJson",
    value: function getJson() {
      var _this6 = this;

      var children = this.list.map(function (l) {
        return _this6.config2Component(l);
      }); // 去重

      var nameObj = {};
      children.forEach(function (child) {
        return nameObj[child.name] = 1;
      });

      if (Object.keys(nameObj).length !== children.length) {
        throw new Error('name repeat!');
      }

      var formObj = _objectSpread(_objectSpread({}, this.formProperty), {}, {
        children: children
      });

      return JSON.stringify(formObj);
    }
  }]);
  return Store;
}();

exports.Store = Store;
var store = new Store();
exports.store = store;